import { put, call, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import { toast } from "react-toastify";
import { GET_DISPUTES, GET_DISPUTE_VIEW } from "../../services/ApiCalls";

function* getDisputesDataSaga({ payload, callBack }) {
  try {
    const response = yield call(GET_DISPUTES, payload);
    if (response.data.status == "success") {
      yield put(ACTION.getDisputesSuccess(response?.data));
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
      yield put(ACTION.getDisputesFail(error));
    }
  } catch (error) {
    yield put(ACTION.getDisputesFail(error));
  }
}

function* getDisputeViewDataSaga({ payload, callBack }) {
  try {
    const response = yield call(GET_DISPUTE_VIEW, payload);
    if (response?.data?.status == "success") {
      console.log(response);
      yield put(ACTION.getDisputesViewSuccess(response?.data?.data));
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
      yield put(ACTION.getDisputesViewFail(error));
    }
  } catch (error) {
    yield put(ACTION.getDisputesViewFail(error));
  }
}

function* disputeSaga() {
  yield takeEvery(CONST.GET_DISPUTES, getDisputesDataSaga);
  yield takeEvery(CONST.GET_DISPUTE_VIEW, getDisputeViewDataSaga);
}

export default disputeSaga;
